require('./hireCardMaestroStep1.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @ constants
const { FIRST_STEP } = require('constants/index');
const { MAESTRO_CARD_PRODUCT_ALIAS,
    MAESTRO_CARD_PRODUCT_MIN_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');


class hireCardMaestroStep1 extends React.Component {

    componentDidMount() {
        const { setTermsAndCondsText } = this.props;

        if (!__CONTACT_CENTER__) {
            const { requestPDFMerge, contracts } = this.props;
            const pdfurls = contracts && contracts.get ? contracts.get('prestacion_servicios_fisicas', '') : '';
            const product = {
                id: MAESTRO_CARD_PRODUCT_MIN_ALIAS
            };
            requestPDFMerge([{ 'url': pdfurls }], [product]);
        } else if (!!setTermsAndCondsText) {
            //This action is also called in the last step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardMaestro-step3CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        if (!__CONTACT_CENTER__) return null;

        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        if (!information) return null

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardMaestro,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendMailParams,
            sendPreContractualMail
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const immStep = immHireCardMaestro.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardMaestro-step3CheckboxText" />; // Re-uses step 3 labels because they have to be the same
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardMaestro-step3CheckboxErrorMsg'); // Re-uses step 3 labels because they have to be the same
        const newSendMailParams = { ...sendMailParams, product: MAESTRO_CARD_PRODUCT_MIN_ALIAS }

        return (
            <section className="hire-card-maestro-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={newSendMailParams}
                />
                <div className="hire-card-maestro-step-one__checkbox-container">
                    <OKCheckbox
                        idName="hireCardMaestroAgreementCheckbox"
                        disabled={!hasBeenEmailSent}
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled,  flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={MAESTRO_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        }
        else {
            productInformationComponent = (
                <article className="hire-card-maestro__step-one">
                    <FormattedText
                        className="hire-card-maestro__step-title"
                        value="hireCardMaestro-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

hireCardMaestroStep1.propTypes = {
    contractName: PropTypes.string,
    contracts: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardMaestro: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func,
};

module.exports = hireCardMaestroStep1;
